import './App.css';
import { Route, Routes } from 'react-router-dom';
import { NavBar } from './Componentes/NavBar';
import { Proyectos } from './Pages/Proyectos';
import { Home } from './Pages/Home';
import { GameJams } from './Pages/GameJams';
//import { initializeApp } from "firebase/app";
import { Footer } from './Componentes/Footer';
import React from 'react';
import { NoEncontrado } from './Componentes/NoEncontrado';
/*
const firebaseConfig = {
  apiKey: "AIzaSyA-wC3IOU4hnGhy9ew_HGpv6TFJT6HlCMA",
  authDomain: "cro128.firebaseapp.com",
  projectId: "cro128",
  storageBucket: "cro128.appspot.com",
  messagingSenderId: "335016298426",
  appId: "1:335016298426:web:9476b222b6f8ff17437f83"
};

const app = initializeApp(firebaseConfig);
*/
function App() {

  return (
    <>
    <NavBar/>
    <Routes>
      <Route path='/' element={<Home />} />
      <Route path='/Proyectos' element={<Proyectos />} />
      <Route path='/GameJams' element={<GameJams />} />
      <Route path='*' element={<NoEncontrado />} />
    </Routes>
    <br/>
    <Footer/>
    </>
  );
}

export default App;
